import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import Dropzone from 'react-dropzone';

class MapCreatorMapUpload extends React.Component {
  constructor(props) {
    super(props);

    this.handleDropMap = this.handleDropMap.bind(this);
  }

  handleDropMap(map_id, accepted_files, rejected_files) {
    this.props.uploadPolygons(map_id, accepted_files, rejected_files);
  }

  render() {
    const { uploading_polygons } = this.props.mapCreator;
    const { map } = this.props;

    return (
      <div>
        {!uploading_polygons ? (
          <Dropzone
            maxSize={5 * 1000 * 1000}
            onDrop={(...args) => this.handleDropMap(map._id, ...args)}
            onDropRejected={() => this.props.notify({ message: 'File too large. 5MB max!'})}
            style={{height: 100}}
            >
            <div className='alert alert-info p-xs'>
              <p className='text-center'><i className='fa fa-plus fa-2x' /></p>
              <p>Drag and drop a KML here to add it's polygons to this map.</p>
            </div>
          </Dropzone>
        ) : (
          <div className='alert alert-info p-xs'>
            <p className='text-center'><i className='fa fa-spinner fa-spin fa-2x' /></p>
            <p>Processing ...</p>
          </div>
        )}
      </div>
    );
  }
}

export default mapCreatorConnect(MapCreatorMapUpload)



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-map-upload.js